import {
  Button,
} from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StepTemplate from 'FRONTEND/components/Calendar/AppointmentForm/StepTemplate';
import { pickDateTime } from 'FRONTEND/reducers/bookingSlice';
import { APPOINTMENT_DURATION_STEP } from 'FRONTEND/utils/constants';
import { getNextStepDateTime } from 'FRONTEND/utils/dateTime';
import i18n from 'FRONTEND/utils/i18n';

export const DateTimeStep = ({
  isCompleted,
  isLocked = false,
  onStepClick = () => {},
  shouldReset = false,
  onStepCompleted = () => {},
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.user.locale);

  useEffect(() => {
    if (shouldReset) {
      dispatch(pickDateTime({ desiredDateTime: null }));
    }
  }, [shouldReset]);

  // Date and time management
  const desiredDateTime = useSelector((state) => state.booking.desiredDateTime);
  const handleDateConfirm = (newDate) => {
    if (newDate?.isValid()) {
      dispatch(pickDateTime({ desiredDateTime: newDate.toISOString() }));
    }
  };

  const handleSubmitClick = () => {
    if (!desiredDateTime) {
      dispatch(pickDateTime({ desiredDateTime: getNextStepDateTime(APPOINTMENT_DURATION_STEP, desiredDateTime).toISOString() }));
    }
    onStepCompleted();
  };

  dayjs.locale(locale);

  return (
    <StepTemplate
      label={i18n._('Select a slot')}
      isLocked={isLocked}
      onEditClick={() => onStepClick()}
      isStepCompleted={desiredDateTime && isCompleted}
      editText={desiredDateTime ? dayjs(desiredDateTime).locale(locale).format('llll') : ''}
      {...otherProps}
    >
      <div className='appointmentForm-line'>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DateTimePicker
            value={dayjs(desiredDateTime || getNextStepDateTime(APPOINTMENT_DURATION_STEP, desiredDateTime).toISOString())}
            onAccept={handleDateConfirm}
            label={i18n._('Desired slot')}
            ampm={false}
            disablePast
            format='llll'
            minutesStep={APPOINTMENT_DURATION_STEP}
            slotProps={{
              field: { onBlur: handleDateConfirm },
              textField: { size: 'small' },
            }}
          />
        </LocalizationProvider>
      </div>
      <div className='appointmentForm-line'>
        <Button
          variant='contained'
          onClick={handleSubmitClick}
        >
          {i18n._('Confirm')}
        </Button>
      </div>
    </StepTemplate>
  );
};
